import { BaseResolver } from "@nx/typescript-domain";
import { IExportArtifactRepository } from "./ExportArtifacts/IExportArtifactRepository";
import { IModelInfoRepository } from "./ModelInfos/IModelInfoRepository";

export class Dependencies extends BaseResolver {
    get exportArtifactRepository() {
        return this.resolve<IExportArtifactRepository>(
            "IExportArtifactRepository"
        );
    }
    get modelInfoRepository() {
        return this.resolve<IModelInfoRepository>("IModelInfoRepository");
    }
}
export const dependencies = new Dependencies();
